import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import './theme/design-system-v2.css';
import reportWebVitals from './reportWebVitals';
import { installDemoShowcaseAxiosInterceptor } from './components/utils/requestContext';
import { installHeroSafeZoneEngine } from './theme/heroSafeZoneEngine';
import FoundationPerformanceProfiler from './performance/FoundationPerformanceProfiler';
import { installFoundationPerformance } from './performance/runtimePerformance';

installDemoShowcaseAxiosInterceptor();
installHeroSafeZoneEngine();
installFoundationPerformance();

const resizeObserverLoopMessages = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

window.addEventListener('error', (event) => {
  if (resizeObserverLoopMessages.includes(event.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message || event.reason;
  if (resizeObserverLoopMessages.includes(message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<FoundationPerformanceProfiler><App /></FoundationPerformanceProfiler>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
